import { CALL_API } from '../middleware/ApiMiddleware';

export const ENTITY_SECTIONS_FETCH_REQUEST = 'ENTITY_SECTIONS_FETCH_REQUEST';
export const ENTITY_SECTIONS_FETCH_SUCCESS = 'ENTITY_SECTIONS_FETCH_SUCCESS';
export const ENTITY_SECTIONS_FETCH_FAILURE = 'ENTITY_SECTIONS_FETCH_FAILURE';

export const ENTITY_SECTION_FETCH_REQUEST = 'ENTITY_SECTION_FETCH_REQUEST';
export const ENTITY_SECTION_FETCH_SUCCESS = 'ENTITY_SECTION_FETCH_SUCCESS';
export const ENTITY_SECTION_FETCH_FAILURE = 'ENTITY_SECTION_FETCH_FAILURE';

export const ENTITY_SECTION_CREATE_REQUEST = 'ENTITY_SECTION_CREATE_REQUEST';
export const ENTITY_SECTION_CREATE_SUCCESS = 'ENTITY_SECTION_CREATE_SUCCESS';
export const ENTITY_SECTION_CREATE_FAILURE = 'ENTITY_SECTION_CREATE_FAILURE';

export const ENTITY_SECTION_EDIT_REQUEST = 'ENTITY_SECTION_EDIT_REQUEST';
export const ENTITY_SECTION_EDIT_SUCCESS = 'ENTITY_SECTION_EDIT_SUCCESS';
export const ENTITY_SECTION_EDIT_FAILURE = 'ENTITY_SECTION_EDIT_FAILURE';

export const ENTITY_ICONS_FETCH_REQUEST = 'ENTITY_ICONS_FETCH_REQUEST';
export const ENTITY_ICONS_FETCH_SUCCESS = 'ENTITY_ICONS_FETCH_SUCCESS';
export const ENTITY_ICONS_FETCH_FAILURE = 'ENTITY_ICONS_FETCH_FAILURE';

export const FETCH_VEHICLE_INFO_REQUEST = 'FETCH_VEHICLE_INFO_REQUEST';
export const FETCH_VEHICLE_INFO_SUCCESS = 'FETCH_VEHICLE_INFO_SUCCESS';
export const FETCH_VEHICLE_INFO_FAILURE = 'FETCH_VEHICLE_INFO_FAILURE';

export const ENTITY_INTEGRATION_FIELDS_REQUEST = 'ENTITY_INTEGRATION_FIELDS_REQUEST';
export const ENTITY_INTEGRATION_FIELDS_SUCCESS = 'ENTITY_INTEGRATION_FIELDS_SUCCESS';
export const ENTITY_INTEGRATION_FIELDS_FAILURE = 'ENTITY_INTEGRATION_FIELDS_FAILURE';

const iconBaseURL = (agencyId: number) => `agencies/${agencyId}/xerce/entity-sections`;

const baseURL = (agencyId: number) => `admin/agencies/${agencyId}/xerce/config/entity-sections`;

const vehicleInfoBaseURL = 'agencies/entity-section';

export const fetchEntitySections = (agencyId: number) => ({
  [CALL_API]: {
    endpoint: baseURL(agencyId),
    method: 'get',
    authenticated: true,
    types: [ENTITY_SECTIONS_FETCH_REQUEST, ENTITY_SECTIONS_FETCH_SUCCESS, ENTITY_SECTIONS_FETCH_FAILURE],
  },
});

export const fetchEntitySection = (agencyId: number, entitySectionId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL(agencyId)}/${entitySectionId}`,
    method: 'get',
    authenticated: true,
    types: [ENTITY_SECTION_FETCH_REQUEST, ENTITY_SECTION_FETCH_SUCCESS, ENTITY_SECTION_FETCH_FAILURE],
  },
});

export const createEntitySection = (agencyId: number, entitySection: IConfigXerceEntitySectionRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL(agencyId)}`,
    method: 'post',
    authenticated: true,
    body: entitySection,
    types: [ENTITY_SECTION_CREATE_REQUEST, ENTITY_SECTION_CREATE_SUCCESS, ENTITY_SECTION_CREATE_FAILURE],
  },
});

export const editEntitySection = (
  agencyId: number,
  entitySectionId: number,
  entitySection: IConfigXerceEntitySectionEditRequest
) => ({
  [CALL_API]: {
    endpoint: `${baseURL(agencyId)}/${entitySectionId}`,
    method: 'put',
    authenticated: true,
    body: entitySection,
    types: [ENTITY_SECTION_EDIT_REQUEST, ENTITY_SECTION_EDIT_SUCCESS, ENTITY_SECTION_EDIT_FAILURE],
  },
});

export const fetchEntityIcons = (agencyId: number) => ({
  [CALL_API]: {
    endpoint: `${iconBaseURL(agencyId)}`,
    method: 'get',
    authenticated: true,
    types: [ENTITY_ICONS_FETCH_REQUEST, ENTITY_ICONS_FETCH_SUCCESS, ENTITY_ICONS_FETCH_FAILURE],
    hideLoadingWidget: true,
  },
});

export const fetchVehicleInfo = (entitySectionId: number, params: IVehicleInfoParams) => ({
  [CALL_API]: {
    endpoint: `${vehicleInfoBaseURL}/${entitySectionId}/integration-response`,
    method: 'get',
    params,
    authenticated: true,
    types: [FETCH_VEHICLE_INFO_REQUEST, FETCH_VEHICLE_INFO_SUCCESS, FETCH_VEHICLE_INFO_FAILURE],
  },
});

export const fetchEntityIntegrationFields = (agencyId: number, entityType: string) => ({
  [CALL_API]: {
    endpoint: `${baseURL(agencyId)}/mappingFields?entityType=${entityType}`,
    method: 'get',
    authenticated: true,
    types: [ENTITY_INTEGRATION_FIELDS_REQUEST, ENTITY_INTEGRATION_FIELDS_SUCCESS, ENTITY_INTEGRATION_FIELDS_FAILURE],
  },
});
